/**
 * RAccordion always renders a `<details>` — a block-level element that holds
 * margin, padding, width and border as authored — and puts styleProps on that
 * element itself. No configuration changes the answer, so no wrapper div,
 * ever.
 */
export const resolveNoContainer = (): boolean => false;
